import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSun, FiMoon } = FiIcons;

function ThemeToggle() {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      className="p-2 rounded-lg bg-government-100 hover:bg-government-200 dark:bg-government-800 dark:hover:bg-government-700 transition-colors"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      <motion.div
        initial={false}
        animate={{ rotate: isDarkMode ? 180 : 0 }}
        transition={{ duration: 0.3 }}
      >
        {isDarkMode ? (
          <SafeIcon icon={FiMoon} className="w-5 h-5 text-government-600 dark:text-government-300" />
        ) : (
          <SafeIcon icon={FiSun} className="w-5 h-5 text-government-600 dark:text-government-300" />
        )}
      </motion.div>
    </motion.button>
  );
}

export default ThemeToggle;